module.exports = __webpack_public_path__ + "img/scrollUp_Icon.a7d2e316.svg";